import { TitleType } from "@tm/models"
import { ReactText } from "react"
import { z } from "zod"

export const getDatVehicleSchema = (t: (key: ReactText) => string, isGermanOrAustrianVehicle?: boolean) => {
    return z.object({
        registrationNo: isGermanOrAustrianVehicle ? z.string().trim().min(1, t(37)) : z.string().optional(),
        initialRegistration: z.date({ required_error: t(289).replace("#1#", "8") }),
        plateNumber: z.string().trim().min(1, t(37)),
        vin: z.string().trim().min(17, t(289).replace("#1#", "17")),
        mileage: z.number({ invalid_type_error: t(37) }).optional(),
    })
}

export const getDatCustomerSchema = () => {
    return z.object({
        titleType: z.nativeEnum(TitleType).optional(),
        firstName: z.string().optional(),
        lastName: z.string().optional(),
        companyName: z.string().optional(),
        street: z.string().optional(),
        streetNo: z.string().optional(),
        zip: z.string().optional(),
        city: z.string().optional(),
        country: z.string().optional(),
        email: z.string().optional(),
        phone: z.string().optional(),
    })
}

export const getDatMainSchema = (translateText: (key: ReactText) => string) =>
    z.object({
        processName: z.string({ required_error: translateText(37) }).min(1, translateText(37)), // Enforces non-empty string
    })

export function isFieldRequired(schema: z.ZodTypeAny, fieldName: string): boolean {
    const baseSchema = schema instanceof z.ZodEffects ? schema._def.schema : schema

    if (!(baseSchema instanceof z.ZodObject)) {
        console.error("Schema must be a ZodObject or ZodEffects<ZodObject>")
    }

    const fieldSchema = baseSchema.shape[fieldName]

    if (!fieldSchema) {
        return false
    }

    const isOptional = fieldSchema instanceof z.ZodOptional || fieldSchema instanceof z.ZodDefault || fieldSchema.safeParse?.(undefined).success

    return !isOptional
}
